import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { ClientSideAnalytics, MessagingCard } from 'src/common/__generated__/api';
import { ErrorType } from 'components/common/ErrorType';
import Content = MessagingCard.Content;

export interface ISearchErrorState {
  pickUpLoc: object | null | boolean;
  dropLoc: object | null | boolean;
  pickUpDate: object | null | boolean;
  dropDate: object | null | boolean;
  pickUpTime: object | null | boolean;
  dropTime: object | null | boolean;
  emptyState: boolean;
  errorType: ErrorType;
}

export interface IErrorState {
  message: string;
  content?: Content;
  analytics: ClientSideAnalytics.Fragment;
  isInvalidField: ISearchErrorState;
}

export const STORE_EVENTS = {
  BFF_SEARCH_POOPED                                       : new SystemEvent(SystemEventLevel.ERROR, 'BFF_SEARCH_POOD'),
  SEARCH_CACHE_ERROR                                      : new SystemEvent(SystemEventLevel.ERROR, 'SEARCH_CACHE_ERROR'),
  LOAD_SEARCH_CACHE_ERROR                                 : new SystemEvent(SystemEventLevel.ERROR, 'LOAD_SEARCH_CACHE_ERROR'),
  SEARCH_FETCH_ERROR                                      : new SystemEvent(SystemEventLevel.INFO, 'SEARCH_FETCH_ERROR'),
  SEARCH_RETURNED_FROM_CACHE                              : new SystemEvent(SystemEventLevel.INFO, 'SEARCH_RETURNED_FROM_CACHE'),
  SHORTLIST_FETCH_FAILED                                  : new SystemEvent(SystemEventLevel.ERROR, 'SHORTLIST_FETCH_FAILED'),
  SHORTLIST_REMOVE_FAILED                                 : new SystemEvent(SystemEventLevel.ERROR, 'SHORTLIST_REMOVE_FAILED'),
  SHORTLIST_ADD_FAILED                                    : new SystemEvent(SystemEventLevel.ERROR, 'SHORTLIST_ADD_FAILED'),
  DETAIL_BASIC_FETCH_FAILED                               : new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_BASIC_FETCH_FAILED'),
  DETAIL_AVAILABILITY_FETCH_FAILED                        : new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_AVAILABILITY_FETCH_FAILED'),
  DETAIL_REVIEWS_FETCH_FAILED                             : new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_REVIEWS_FETCH_FAILED'),
  DETAIL_OFFERS_FETCH_FAILED                              : new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_OFFERS_FETCH_FAILED'),
  DETAIL_OFFER_FETCH_FAILED                               : new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_OFFER_FETCH_FAILED'),
  DETAIL_RECOMMENDATION_FETCH_FAILED                      : new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_RECOMMENDATION_FETCH_FAILED'),
  CREATE_TRIP_FAILURE                                     : new SystemEvent(SystemEventLevel.ERROR, 'CREATE_TRIP_FAILURE'),
  TRIP_ID_NOT_RETURNED                                    : new SystemEvent(SystemEventLevel.ERROR, 'TRIP_ID_NOT_RETURNED'),
  REVIEW_UPVOTE_FAILED                                    : new SystemEvent(SystemEventLevel.ERROR, 'REVIEW_UPVOTE_FAILED'),
  MARKETING_INFO_PARSING_FAILED                           : new SystemEvent(SystemEventLevel.ERROR, 'MARKETING_INFO_PARSING_FAILED'),
  DROP_OFF_AVAILABILITY_FETCH_FAILED                      : new SystemEvent(SystemEventLevel.ERROR, 'DROP_OFF_AVAILABILITY_FETCH_FAILED'),
  RNR_FETCH_FAILED                                        : new SystemEvent(SystemEventLevel.ERROR, 'RNR_FETCH_FAILED'),
  BEX_API_MULTI_ITEM_SELECT_PRODUCTS_ERROR                : new SystemEvent(SystemEventLevel.ERROR, 'SELECT_PRODUCTS_FAILED'),
  BEX_API_MULTI_ITEM_PREPARE_CHECKOUT_BY_SESSION_ID_ERROR : new SystemEvent(
    SystemEventLevel.ERROR,
    'PREPARE_CHECKOUT_BY_SESSION_ID_FAILED'
  )
};

export const SPINNERS_ERRORS = {
  PickupDateFailureEvent                        : 'pickUpDate',
  DropOffDateTimeFailureEvent                   : 'dropDate',
  DropOffDateFailureEvent                       : 'pickUpDate,dropDate',
  PickupTimeFailureEvent                        : 'pickUpTime',
  DropOffTimeFailureEvent                       : 'dropTime',
  PickupDropOffTimeFailureEvent                 : 'pickUpTime,dropTime',
  PickupDateAfterDropOffDateEvent               : 'dropDate',
  PickupTimeAfterDropOffTimeEvent               : 'dropTime',
  //Ignoring the following events because we don't need highlight the error field
  //TripTooLongFailureEvent,
  //TripTooShortFailureEvent,
  Downstreamfailurevent                         : 'emptyState',
  DownstreamServiceFailureEvent                 : 'emptyState',
  CarInventoryNotAvailableEvent                 : 'emptyState',
  PickupRegionResolveFailureEvent               : 'emptyState',
  DropOffRegionResolveFailureEvent              : 'emptyState',
  PickupRegionDisambigEvent                     : 'emptyState',
  DropOffRegionDisambigEvent                    : 'emptyState',
  MultiItemSessionNotFoundEvent                 : 'emptyState',
  MultiItemFlightDetailsFailureEvent            : 'emptyState',
  CarsNotAvailableEvent                         : 'emptyState',
  NoInventoryFoundEvent                         : 'emptyState',
  MultiItemDownstreamServiceFailureEvent        : 'emptyState',
  MultiItemSessionDownstreamServiceFailureEvent : 'emptyState',
  MultiItemGeoDownstreamServiceFailureEvent     : 'emptyState'
};
